import mockReleaseData from "../../data/mockData/releasesData";
import { types } from "./action";

/**
 * Demo catalog lives in Redux for visibility and merges with browser session creates.
 * - seed: static mock rows (same module as mockApi)
 * - tableRowResults: last paginated GET /releases/ page from mock or API
 * - created: rows appended after POST /releases/ (browser-session persists in sessionStorage too)
 */
const initialState = {
  seed: mockReleaseData,
  tableRowResults: [],
  created: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_RELEASES:
      return {
        ...state,
        tableRowResults: Array.isArray(action.payload) ? action.payload : state.tableRowResults,
      };
    case types.ADD_RELEASE: {
      const row = action.payload;
      if (!row || row.id == null) {
        return state;
      }
      const exists = state.created.some(r => String(r.id) === String(row.id));
      if (exists) {
        return state;
      }
      return {
        ...state,
        created: [...state.created, row],
      };
    }
    default:
      return state;
  }
};
